import { ReactElement, ReactNode } from 'react';

import TenantFeatureSubscriptionsProviderContext from '../contexts/tenant-feature-subscriptions-provider-context';
import useTenantFeatureSubscriptions from '../hooks/tenant-feature-subscriptions';

type TenantFeatureSubscriptionsProviderProps = {
  children: ReactNode;
};

const TenantFeatureSubscriptionsProvider = ({ children }: TenantFeatureSubscriptionsProviderProps): ReactElement => (
  <TenantFeatureSubscriptionsProviderContext value={useTenantFeatureSubscriptions()}>{children}</TenantFeatureSubscriptionsProviderContext>
);

export default TenantFeatureSubscriptionsProvider;
